const initSurveyTabHandler = (currentPageName) => {
	tabHandler(currentPageName ? $('#' + currentPageName) : $());
};
